import { confirm } from "@soft-db/ui";
import { onUnmounted } from "vue";
import { useRouter } from "vue-router";

export const useConfirmLeave = (condition: () => boolean, msg: string) => {
	const router = useRouter();

	const disable = ref(false);

	const route = useRoute();
	// In case the route change, but this hook still is mounted.
	watch(
		() => route.fullPath,
		() => {
			disable.value = false;
		}
	);

	const routerBeforeHook = router.beforeEach(async (to, from, next) => {
		if (to.path === from.path || !condition() || disable.value) {
			return next();
		}

		if (await confirm(msg)) {
			disable.value = true;
			return next();
		} else {
			return next(false);
		}
	});

	const beforeUnload = (event: BeforeUnloadEvent) => {
		if (!condition()) return;

		// For Firefox
		event.preventDefault();

		// For Chromium
		event.returnValue = "";
		return event;
	};

	window.addEventListener("beforeunload", beforeUnload);

	onUnmounted(() => {
		routerBeforeHook();
		window.removeEventListener("beforeunload", beforeUnload);
	});
};
